<div class="container">
  <div class="row">
    <div class="col">
      <h4>{{appointment.doctor.name}} | {{appointment.appointment.date | date:'dd/MM/yyy'}} <small style="font-size: smaller;">{{appointment.appointment.date | date:'hh:mm a'}}-{{appointment.appointment.end_date | date:'hh:mm a'}}
        @if (appointment.appointment.status==='COMPLETED') {
          <span class="badge bg-success mx-1" style="font-size: x-small;">{{appointment.appointment.status}}</span>
        }
      </small></h4>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-outline-dark mx-1 mt-1"
        [hidden]="is_hidden_appointment(appointment.appointment)"
        [disabled]="allowed_to_close(appointment.appointment)"
        (click)="open_invocie_modal(invoice_content)">Invoice
      Payment</button>
      <button type="button" class="btn btn-outline-success mx-1 mt-1" [hidden]="is_hidden(appointment.appointment)"
      (click)="open(service_content)">Add Service</button>
      <button type="button" class="btn btn-outline-success mx-1 mt-1" [hidden]="is_hidden(appointment.appointment)"
      (click)="open(items_content)">Buy an item</button>
      <a class="btn btn-dark mx-2"
        (click)="print_invoice(appointment?.appointment.payment_id)"
      [hidden]="!is_hidden_appointment(appointment.appointment)">Print Invoice</a>
      <button type="button" class="btn  btn-outline-danger mx-1 mt-1" [disabled]="!utility.isAllowed(['admin', 'accountant', 'doctor'])"
      (click)="onDeleteAppointment(appointment.appointment)">Delete</button>
      <!-- <button type="button" class="btn btn-outline-danger mx-1" (click)="disablePackage(package)"
    *ngIf="package">Remove Package</button> -->
  </div>
</div>
<hr>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class="card">
        <div class="card-header">
          Patient
          <span class="float-end">
            {{ appointment?.patient.patient_number }}
          </span>
        </div>
        <div class="card-body">
          <h5 class="card-title">{{ appointment?.patient.first_name }} {{ appointment?.patient.last_name }}
            @if (utility.isAllowed(['admin', 'accountant'])) {
              <span class="float-end" style="font-size: small;">
                <a [routerLink]="['/patient_details']"
                [queryParams]="{ id: appointment?.appointment.patient_id }">view patient page</a>
              </span>
            }
          </h5>
          <p class="card-text">
            Occupation: {{ appointment?.patient.visiting_reason}}
          </p>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">{{ appointment?.patient.gender}}</li>
          @if (utility.isAllowed(['admin', 'accountant'])) {
            <li class="list-group-item">Mobile: <span class="float-end">{{ appointment?.patient.phone}}</span>
          </li>
        }
        @if (appointment?.patient?.phone2 && utility.isAllowed(['admin', 'accountant'])) {
          <li class="list-group-item">Secandary Phone <span
          class="float-end">{{appointment?.patient?.phone2}}</span>
        </li>
      }
      <li class="list-group-item">Age: <span class="float-end">{{appointment.patient.age}} years old</span></li>
      @if (utility.isAllowed(['admin', 'accountant'])) {
        <li class="list-group-item">Birth Date: <span class="float-end">{{ appointment?.patient.birth_date |
        date:'dd MMM y'}}</span></li>
      }
      <li class="list-group-item">Registration Date: <span class="float-end">{{
      appointment?.patient.created_at | date:'dd MMM y'}}</span></li>
    </ul>
    <div class="card-footer">
      <div class="btn-group mr-2 btn-group" role="group" aria-label="First group" dir="auto">
        <a [routerLink]="['/invoices']" [queryParams]="{id: appointment?.appointment.patient_id}"
          class="btn btn-outline-primary">Check
        Invoices</a>
        <a [routerLink]="['/appointments']"
          [queryParams]="{patient: appointment?.appointment.patient_id}"
        class="btn btn-outline-dark">Check Appointments</a>
      </div>
    </div>
  </div>
  @if (package) {
    <div class="card mt-3">
      <div class="card-header">
        Patient Package
      </div>
      <div class="card-body" style="padding: 0;">
        <table class="table table-bordered" id="excel-table" style="margin: 0;">
          <thead>
            <tr class="table-secondary">
              <th>Sessions</th>
              <th>Left</th>
              <th>Taken</th>
              <th>Price</th>
              <th>Paied</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{package.no_sessions}}</td>
              <td>{{package.no_sessions_left}}</td>
              <td>{{package.no_sessions_took}}</td>
              <td>{{package.full_price}}</td>
              <td>{{package.paied_amount}} <small>OMR</small> </td>
              <td>{{package.created_at | date: 'dd/MM/yyyy'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  }
  <div class="card mt-3">
    <div class="card-header">
      Services
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        Services:
        <ul>
          <li>{{ appointment?.appointment.service_name}} <span class="badge bg-warning mx-1">{{ get_room(appointment?.appointment.room) }}</span></li>
          @for (sub of sub_appointments; track sub) {
            <li>
              {{get_service_name(sub.service_id)}}
            </li>
          }
        </ul>
      </li>
      <li class="list-group-item">
        Services Prices:
        <ul>
          @if (!package) {
            <li>{{ appointment?.appointment.final_price | number }}
              <small><b>OMR</b></small>
            </li>
          }
          @if (package) {
            <li><small>{{package.full_price}}
              <small><b>OMR</b></small></small></li>
            }
            @for (sub of sub_appointments; track sub) {
              <li>
                {{sub.amount_due}} <small><b>OMR</b></small>
              </li>
            }
          </ul>
        </li>
        @if (appointment?.appointment.recommended_by) {
          <li class="list-group-item">
            Recommended by:
            <ul>
              <li>{{ get_doctor_name(appointment?.appointment.recommended_by) }}</li>
            </ul>
          </li>
        }
        @if (history.length>0) {
          <li class="list-group-item">
            Past Sessions:
            <ul>
              @for (item of history; track item) {
                <li>
                  {{ item.date | date:'dd/MM/yy hh:mm:ss'}}
                  <span class="badge bg-secondary mx-1">{{ item.room }}</span>
                  {{ get_doctor_name(item.doctor_id) }}
                  <small>
                    <span style="padding-left: 5px;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-journal-text" viewBox="0 0 16 16">
                        <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
                        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
                        <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
                      </svg>
                    </span>
                    <span style="color: blue; padding-left: 3px;">{{item.note_count}}</span>
                  </small>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  </div>
  <div class="col-lg-6 col-md-6 col-sm-12">
    <div class="card">
      <div class="card-header">
        Clinician Notes
      </div>
      <div class="card-body" style="padding: 0px;">
        @if (note.length > 0) {
          <div>
            @for (n of note; track n) {
              <ul class="list-group list-group-flush pb-3">
                <li class="list-group-item" style="background-color: #f6f6f6;"><b>{{ n?.title}} </b> -
                <small> {{ n?.open_date | date:'dd MMM y'}}</small>
                @if (api.canEnter(['doctor', 'admin'])) {
                  <div class="btn-group mr-2 btn-group-sm float-end" role="group" aria-label="First group"
                    >
                    <button type="button" class="btn btn-sm btn-warning" [disabled]="allowed_to_close(appointment.appointment)"
                      (click)="edit(contentNoteEdit, n)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path
                          d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                      </svg>
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" [disabled]="!utility.isAdmin()" (click)="OnDelete(n.id)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                      </svg>
                    </button>
                  </div>
                }
              </li>
              <!-- <li class="list-group-item">{{ n?.diagnosis }} </li> -->
              <li class="list-group-item">
                <textarea [disabled]="true" class="form-control" rows="20" cols="100" [value]="n?.description"></textarea>
              </li>
            </ul>
          }
        </div>
      }
    </div>
    @if (api.canEnter(['doctor', 'admin'])) {
      <div class="card-footer">
        <button type="button" class="btn btn-primary" (click)="open(contentNoteNew)" [disabled]="allowed_to_close(appointment.appointment)">Add New
        Note</button>
        <a class="btn btn-dark mx-2" (click)="print_note(note)">
          Print Notes
        </a>
        <a type="button" class="btn btn-outline-dark position-absolute end-0 mx-2" (click)="getHistoryNotes()">Click here to show Patient's Notes History</a>
      </div>
    }
  </div>
</div>
</div>
<div class="row">
  <ng-template #invoice_content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Create Invoice</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <div class="row">
          <label class="form-label">Payment Details</label>
          <table class="table table-bordered">
            <thead>
              <tr style="background-color:aliceblue;">
                <th>Service</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Total</th>
                <th></th>
                <!-- <th>-</th> -->
              </tr>
            </thead>
            <tbody>
              @for (item of payment_services; track item) {
                <tr>
                  <td>{{item.service_name}}</td>
                  <td>{{item.service_price}}</td>
                  <td>{{item.quantity}}</td>
                  <td>{{item.final_price | number : '1.2-2'}}</td>
                  <td>
                    <span class="text-danger" (click)="removeService(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash3-fill" viewBox="0 0 16 16">
                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                      </svg>
                    </span>
                  </td>
                  <!-- <td><button type="button" class="btn btn-sm btn-danger" (click)="onPop(item)">'Delete'</button></td> -->
                </tr>
              }
              <tr>
                <td colspan="3">
                  Total to Pay
                </td>
                <td style="background-color:aliceblue;">
                  {{(payment.final_price | number : '1.2-2')}}
                </td>
                <td></td>
              </tr>
              @if (package) {
                <tr>
                  <td colspan="3">
                    Package Payment
                  </td>
                  <td style="background-color:aliceblue;">
                    <sup>{{package.paied_amount}}</sup>/<sub>{{package.full_price}}</sub>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <!-- <div class="row mt-2" *ngIf="invoice.payment_package === 'INSTALLMENT'">
        <div class="col">
          <label for="date" class="form-label">Payment Amount of Package</label>
          <input type="number" class="form-control" [(ngModel)]="package_payment_amount">
        </div>
      </div> -->
      <div class="row mt-2">
        <div class="col">
          <label for="date" class="form-label">Payment Type</label>
          <select class="form-select" [(ngModel)]="payment.payment_type">
            <option [value]="'CASH'">CASH</option>
            <option [value]="'CARD'">CARD</option>
            <option [value]="'BANK'">BANK</option>
            <option [value]="'CHEQUE'">CHEQUE</option>
          </select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <label for="price" class="form-label">Discounted Price <small>(finall price)</small></label>
          <input type="number" class="form-control" [(ngModel)]="payment.final_price_to_pay" id="price">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="create()">Create Invoice</button>
  </div>
</ng-template>
<ng-template #contentNoteNew let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <!-- <div class="mb-3">
      <label for="diagnosis" class="form-label">Title</label>
      <textarea class="form-control" id="diagnosis" rows="2" cols="50"
      [(ngModel)]="notes.diagnosis"></textarea>
    </div> -->
    <div class="mb-3">
      <!-- <label for="notes" class="form-label">Details</label> -->
      <textarea class="form-control" id="notes" rows="10" cols="50"
      [(ngModel)]="notes.description"></textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="OnSumbit()">Submit Note</button>
</div>
</ng-template>
<ng-template #contentNoteEdit let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <!-- <div class="mb-3">
      <label for="diagnosis" class="form-label">Title</label>
      <textarea class="form-control" id="diagnosis" rows="2" cols="50"
      [(ngModel)]="edit_notes.diagnosis"></textarea>
    </div> -->
    <div class="mb-3">
      <!-- <label for="notes" class="form-label">Details</label> -->
      <textarea class="form-control" id="notes" rows="10" cols="50"
      [(ngModel)]="edit_notes.description"></textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="OnUpdate(note_id)">Edit Note</button>
</div>
</ng-template>
<ng-template #service_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Add Extra Service</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="service" class="form-label">Type of Service</label>
          <select class="form-select" [(ngModel)]="service.id" (change)="getPrice()">
            <option [ngValue]="null">-- SELECT SERVICE --</option>
            @for (service of services; track service) {
              <option [ngValue]='service.id'>{{ service.name }}
              </option>
            }
          </select>
        </div>
        <div class="col">
          <label for="amount_due" class="form-label">Quantity</label>
          <input type="number" class="form-control" [(ngModel)]="service.quantity" id="amount_due"
            (change)="calculate_service()" (keyup)="calculate_service()" min="1">
        </div>
        <div class="col">
          <label for="price" class="form-label">Price</label>
          <input type="number" class="form-control" [(ngModel)]="service.final_price" id="price"
            disabled>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="price" class="form-label">Recommended by</label>
          <select class="form-select" [(ngModel)]="service.recommended_by">
            <option [ngValue]="null">-- SELECT --</option>
            @for (staff of staffs; track staff) {
              <option [ngValue]='staff.id'>{{ staff.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="add_service()">Add Service</button>
    <button type="button" class="btn btn-outline-dark"
    (click)="modal.dismiss('Cross click')">Cancel</button>
  </div>
</ng-template>
<ng-template #items_content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Buy extra Items</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="service" class="form-label">Select an Item</label>
          <select class="form-select" [(ngModel)]="item.id" (change)="getItemPrice()">
            <option [ngValue]="null">-- SELECT ITEM --</option>
            @for (item of items; track item) {
              <option [ngValue]='item.id'>{{ item.name }}
              </option>
            }
          </select>
        </div>
        <div class="col">
          <label for="amount_due" class="form-label">Quantity</label>
          <input type="number" class="form-control" [(ngModel)]="item.quantity" id="amount_due"
            (change)="calculate_item()" min="1">
        </div>
        <div class="col">
          <label for="price" class="form-label">Price</label>
          <input type="number" class="form-control" [(ngModel)]="item.final_price" id="price"
            disabled>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="price" class="form-label">Recommended by</label>
          <select class="form-select" [(ngModel)]="service.recommended_by">
            <option [ngValue]="null">-- SELECT --</option>
            @for (staff of staffs; track staff) {
              <option [ngValue]='staff.id'>{{ staff.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="add_item()">Add Item</button>
    <button type="button" class="btn btn-outline-dark"
    (click)="modal.dismiss('Cross click')">Cancel</button>
  </div>
</ng-template>
</div>
<br>
</div>